import { render, staticRenderFns } from "./NotaryVerify.vue?vue&type=template&id=ebfe0b78&scoped=true&"
import script from "./NotaryVerify.vue?vue&type=script&lang=js&"
export * from "./NotaryVerify.vue?vue&type=script&lang=js&"
import style0 from "./NotaryVerify.vue?vue&type=style&index=0&id=ebfe0b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfe0b78",
  null
  
)

export default component.exports